import React from "react";
import { ArcStack } from "@src/core/ui";
import { OrdersWrapperView, ToggleCollapseView } from '@src/features/order/pages/orders-page/components';
import { ArcOrderCard } from "@src/core/components";
import { OrderStatusEnum } from "@src/features/order/entities";
import { ORDER_COLUMN_CELL_SX } from '@src/features/order/pages/orders-page/constants';
import { useNavigate } from "react-router-dom";
import ViewAllButton from '@src/features/order/pages/orders-page/actions/view-all-button';
import { CancelledSectionProps } from "./types";

const CancelledSection: React.FC<CancelledSectionProps> = (props) => {
  const { orders, selected, onSelectOrder, count } = props;
  const navigate = useNavigate();

  const redirectToHistory = (status?: OrderStatusEnum) => {
    const url = status ? `/app/history?status=${status}` : "/app/history";

    navigate(url);
  };

  return (
    <ArcStack direction='column' sx={ORDER_COLUMN_CELL_SX}>
      <ToggleCollapseView
        count={count}
        status={OrderStatusEnum.CANCELLED}
      >
        <OrdersWrapperView>
          {orders.slice(0, 5).map((order, index) => {
            const orderId =
              (order as any).orders?.[0]?.id ||
              (order as any).id ||
              (order as any).missionId;
            const selectedId =
              (selected as any)?.orders?.[0]?.id ||
              (selected as any)?.id ||
              (selected as any)?.missionId;

            return (
              <ArcOrderCard
                key={orderId}
                order={order}
                isSelected={!!(orderId && selectedId && orderId === selectedId)}
                onClick={() => onSelectOrder(order, OrderStatusEnum.CANCELLED)}
                index={index}
                status={OrderStatusEnum.CANCELLED}
                sx={{ width: '100%', minHeight:'110px' }}
              />
            );
          })}
          {count > 5 && (
            <ViewAllButton
              onClick={() => redirectToHistory(OrderStatusEnum.CANCELLED)}
            />
          )}
        </OrdersWrapperView>
      </ToggleCollapseView>
    </ArcStack>
  );
};

export default CancelledSection;
